import Icon from 'veui/components/Icon'

Icon.register({
  'mark-x': {
    paths: [
      {
        d: 'M429.25 384l233.38-233.37a32 32 0 00-45.26-45.26L384 338.75 150.63 105.37a32 32 0 00-45.26 45.26L338.75 384 105.37 617.37a32 32 0 0045.26 45.26L384 429.25l233.37 233.38a32 32 0 0045.26-45.26z'
      }
    ],
    width: '768',
    height: '768'
  }
})
